import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=32dea78d"
import script from "./workList.vue?vue&type=script&lang=js"
export * from "./workList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports